module.exports = __webpack_public_path__ + "f9e8c53d5ff049c831fbe2baa0c266a9.svg";